import React, {Component} from 'react';
import * as firebase from 'firebase';
import ReactLoading from 'react-loading';
import FbIcon from '../images/icon-fb.svg';
import GoogleIcon from '../images/icon-google.svg';
import TwitterIcon from '../images/icon-twitter.svg';

export default class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      displayName: '',
      photoURL: '',
      gender: '',
      birthday: '',
      otherMail: '',
      phone: '',
      address: '',
      height: '',
      weight: '',
      quiz: '',
      loading: false
    }

    this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
    this.handleFaceBookLogin = this.handleFaceBookLogin.bind(this);
    this.handleTwitterLogin = this.handleTwitterLogin.bind(this);
  }
  componentDidMount(){
    window.scrollTo(0,0);
  }

  handleGoogleLogin() {
   var provider = new firebase.auth.GoogleAuthProvider();
   firebase.auth().signInWithRedirect(provider).then((result) => {
    //  var user = result.user;
    //  console.log(user)
    // window.history.back();
   }).catch((error) => {
     var errorMessage = error.message;
     alert(errorMessage)
   })
  }
  handleFaceBookLogin() {
   var provider = new firebase.auth.FacebookAuthProvider();
   firebase.auth().signInWithRedirect(provider).then((result) => {
    //  window.location = ('/UserProfile/Personal');
    // window.history.back();
   }).catch((error) => {
     var errorMessage = error.message;
     alert(errorMessage)
   })
  }
  handleTwitterLogin() {
   var provider = new firebase.auth.TwitterAuthProvider()
   firebase.auth().signInWithRedirect(provider).then((result) => {
    // window.history.back();
   }).catch((error) => {
      var errorMessage = error.message;
      alert(errorMessage)
   })
  }
  render() {
    const { loading } = this.state;
    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }
    return(
      <div className="container hasPadding">
       <div className="row">
         <form className="form" ref="goLogin">
          <h2 className="mobilenone">請使用您習慣的第三方登入方式</h2>
          <p className="mobilenone">如果第三方都使用一樣的信箱註冊,只會紀錄第一次登入的第三方平台資訊喔!</p>
          <div className="loginBox">
           <a className="fb" onClick={this.handleFaceBookLogin}><p><span style={Jeyu.Fb}></span>臉書登入</p></a>
           <a className="google" onClick={this.handleGoogleLogin}><p><span style={Jeyu.Google}></span>谷歌登入</p></a>
           <a className="twitter" onClick={this.handleTwitterLogin}><p><span style={Jeyu.Twitter}></span>推特登入</p></a>
          </div>
         </form>
       </div>
      </div>
    )
  }
}

const Jeyu = {
  Fb: {
    background: 'url('+FbIcon+')',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: 100,
    width: 100,
    display: 'block',
    cursor: 'pointer'
  },
  Google: {
    background: 'url('+GoogleIcon+')',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: 100,
    width: 100,
    display: 'block',
    cursor: 'pointer'
  },
  Twitter: {
    background: 'url('+TwitterIcon+')',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: 100,
    width: 100,
    display: 'block',
    cursor: 'pointer'
  },
  cursor: {
    cursor: 'pointer'
  },
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  }
}



// WEBPACK FOOTER //
// ./src/View/Login.js